import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import commonVi from './vi/common.json';
import commonEn from './en/common.json';
import commonJa from './ja/common.json';
import commonKo from './ko/common.json';
import commonZh from './zh/common.json';

import dashboardVi from './vi/dashboard.json';
import dashboardEn from './en/dashboard.json';
import dashboardJa from './ja/dashboard.json';
import dashboardKo from './ko/dashboard.json';
import dashboardZh from './zh/dashboard.json';

import accountVi from './vi/account.json';
import accountEn from './en/account.json';
import accountJa from './ja/account.json';
import accountKo from './ko/account.json';
import accountZh from './zh/account.json';

import campaignVi from './vi/campaign.json';
import campaignEn from './en/campaign.json';
import campaignJa from './ja/campaign.json';
import campaignKo from './ko/campaign.json';
import campaignZh from './zh/campaign.json';

import taskVi from './vi/task.json';
import taskEn from './en/task.json';
import taskJa from './ja/task.json';
import taskKo from './ko/task.json';
import taskZh from './zh/task.json';

import settingsVi from './vi/settings.json';
import settingsEn from './en/settings.json';
import settingsJa from './ja/settings.json';
import settingsKo from './ko/settings.json';
import settingsZh from './zh/settings.json';

import workflowVi from './vi/workflow.json';
import workflowEn from './en/workflow.json';
import workflowJa from './ja/workflow.json';
import workflowKo from './ko/workflow.json';
import workflowZh from './zh/workflow.json';

import seedingContentsVi from './vi/seedingContents.json';
import seedingContentsEn from './en/seedingContents.json';
import seedingContentsJa from './ja/seedingContents.json';
import seedingContentsKo from './ko/seedingContents.json';
import seedingContentsZh from './zh/seedingContents.json';

import leadsVi from './vi/leads.json';
import leadsEn from './en/leads.json';
import leadsJa from './ja/leads.json';
import leadsKo from './ko/leads.json';
import leadsZh from './zh/leads.json';

import reportsVi from './vi/reports.json';
import reportsEn from './en/reports.json';
import reportsJa from './ja/reports.json';
import reportsKo from './ko/reports.json';
import reportsZh from './zh/reports.json';

import schedulesVi from './vi/schedules.json';
import schedulesEn from './en/schedules.json';
import schedulesJa from './ja/schedules.json';
import schedulesKo from './ko/schedules.json';
import schedulesZh from './zh/schedules.json';

import fanpageVi from './vi/fanpage.json';
import fanpageEn from './en/fanpage.json';
import fanpageJa from './ja/fanpage.json';
import fanpageKo from './ko/fanpage.json';
import fanpageZh from './zh/fanpage.json';

// Default locale: read from localStorage (synced from biztada-app shell)
const STORAGE_KEY = 'biztada-language';
function loadLocale(): string {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && ['vi', 'en', 'ja', 'ko', 'zh'].includes(saved)) return saved;
  } catch {}
  return 'vi';
}

i18n.use(initReactI18next).init({
  resources: {
    vi: {
      common: commonVi,
      dashboard: dashboardVi,
      account: accountVi,
      campaign: campaignVi,
      task: taskVi,
      settings: settingsVi,
      workflow: workflowVi,
      seedingContents: seedingContentsVi,
      leads: leadsVi,
      reports: reportsVi,
      schedules: schedulesVi,
      fanpage: fanpageVi,
    },
    en: {
      common: commonEn,
      dashboard: dashboardEn,
      account: accountEn,
      campaign: campaignEn,
      task: taskEn,
      settings: settingsEn,
      workflow: workflowEn,
      seedingContents: seedingContentsEn,
      leads: leadsEn,
      reports: reportsEn,
      schedules: schedulesEn,
      fanpage: fanpageEn,
    },
    ja: {
      common: commonJa,
      dashboard: dashboardJa,
      account: accountJa,
      campaign: campaignJa,
      task: taskJa,
      settings: settingsJa,
      workflow: workflowJa,
      seedingContents: seedingContentsJa,
      leads: leadsJa,
      reports: reportsJa,
      schedules: schedulesJa,
      fanpage: fanpageJa,
    },
    ko: {
      common: commonKo,
      dashboard: dashboardKo,
      account: accountKo,
      campaign: campaignKo,
      task: taskKo,
      settings: settingsKo,
      workflow: workflowKo,
      seedingContents: seedingContentsKo,
      leads: leadsKo,
      reports: reportsKo,
      schedules: schedulesKo,
      fanpage: fanpageKo,
    },
    zh: {
      common: commonZh,
      dashboard: dashboardZh,
      account: accountZh,
      campaign: campaignZh,
      task: taskZh,
      settings: settingsZh,
      workflow: workflowZh,
      seedingContents: seedingContentsZh,
      leads: leadsZh,
      reports: reportsZh,
      schedules: schedulesZh,
      fanpage: fanpageZh,
    },
  },
  lng: loadLocale(),
  fallbackLng: 'vi',
  defaultNS: 'common',
  ns: ['common', 'dashboard', 'account', 'campaign', 'task', 'settings', 'workflow', 'seedingContents', 'leads', 'reports', 'schedules', 'fanpage'],
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
